import React, { useMemo } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { useModalContext } from "common/contexts";
import { Row } from "common/components";
import SetStatusControl from "security-app/components/SecurityEvents/Alerts/EventDetails/SetStatusControl";
import Routes from "routing/Routes";
import { LinkContainer } from "components/common";
import OwnerAction from "security-app/components/SecurityEvents/Alerts/EventDetails/OwnerAction";
import useCanEditSecurityEvent from "security-app/components/SecurityEvents/Alerts/hooks/useCanEditSecurityEvent";
const RowCol = styled(Row)`
  flex-direction: ${({ $orientation }) => $orientation === "vert" ? "column" : "row"};
  /* Wrap the two halves (buttons / owner+status) when horizontal space is tight, so the
     right-aligned owner/status controls drop to the next line instead of overflowing
     into the columns to the right. */
  flex-wrap: wrap;
  row-gap: 0.5rem;
`;
const ActionsGroup = styled(Row)`
  /* Default Row width is 100% which would force-wrap a sibling onto the next line even
     when there's room for both on the same row. Shrink to content instead. */
  width: auto;
  /* Each half should also wrap internally if its own children can't fit on one line. */
  flex-wrap: wrap;
  row-gap: 0.5rem;
`;
const RightActionsGroup = styled(ActionsGroup)`
  /* Keeps the owner/status controls glued to the right edge whether they share the line
     with the buttons or wrap onto the next one. */
  margin-left: auto;
`;
function ActionsRow({ securityEvent, orientation = "horz", showReplayAction = true }) {
  const { setModal, setEntity } = useModalContext();
  const hideReplayAction = useMemo(
    () => !showReplayAction || !!securityEvent.event.event_definition_type.match(/system-notification/i) || !securityEvent.event.replay_info,
    [securityEvent.event.event_definition_type, securityEvent.event.replay_info, showReplayAction]
  );
  const canManageSecurityEvents = useCanEditSecurityEvent(securityEvent.id);
  const openEvidenceModal = () => {
    const { event } = securityEvent;
    setEntity([event.id]);
    setModal("ADD-EVIDENCE");
  };
  const sendNotification = () => {
    setEntity(securityEvent);
    setModal("SEND-NOTIFICATION");
  };
  const onStatusChange = (newStatus) => {
    if (newStatus !== securityEvent.status) {
      setEntity({ securityEvent, newStatus });
      setModal("CONFIRM-STATUS-CHANGE");
    }
  };
  return /* @__PURE__ */ React.createElement(RowCol, { $orientation: orientation }, /* @__PURE__ */ React.createElement(ActionsGroup, { $align: "center", $justify: "flex-start", $gap: "md" }, hideReplayAction || /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.ALERTS.replay_search(securityEvent.event_id), target: "_blank" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "sm" }, "Replay Search")), !canManageSecurityEvents || /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", onClick: openEvidenceModal }, "Add to an Investigation"), !canManageSecurityEvents || /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", onClick: sendNotification }, "Send Notification")), /* @__PURE__ */ React.createElement(RightActionsGroup, { $align: "center", $justify: "flex-end", $gap: "xl" }, canManageSecurityEvents ? /* @__PURE__ */ React.createElement(OwnerAction, { securityEvent }) : /* @__PURE__ */ React.createElement("td", null), /* @__PURE__ */ React.createElement(Row, { $align: "center", $width: "auto" }, /* @__PURE__ */ React.createElement(
    SetStatusControl,
    {
      onStatusChange,
      value: securityEvent.status,
      disabled: !canManageSecurityEvents
    }
  ))));
}
export default ActionsRow;
